export const CODE_EDITOR_ROUTE = '/files/code-editor';

export function buildCodeEditorSearch(mountId: string, relativePath: string): string {
  const params = new URLSearchParams();
  params.set('mountId', mountId);
  params.set('path', relativePath);
  return params.toString();
}

export function codeEditorHref(mountId: string, relativePath: string): string {
  return `${CODE_EDITOR_ROUTE}?${buildCodeEditorSearch(mountId, relativePath)}`;
}
